import {ChangeDetectionStrategy, Component, Input,} from '@angular/core';
import {BaseComponent} from 'compob2b-libs';
import {ListFilterService} from '../../services/list-filter.service';
import { AsyncPipe } from "@angular/common";

@Component({
    selector: 'app-filter-count',
    template: `
    @if (filter.getCtnActiveFeatures() | async; as cnt) {
      <div class="count-filter">
        {{ cnt }}
      </div>
    }
    `,
    styles: `
      :host {
        position: relative;
        display: inline-block;
        /*width: 24px;*/
        /*height: 24px;*/
      }

      .count-filter {
        background: var(--button-filled-primary-background-color);
        font-size: 12px;
        line-height: 20px;
        color: var(--button-filled-primary-text-color);
        padding: 0;
        border-radius: 50%;
        z-index: 10;
        width: 18px;
        height: 18px;
        margin: -2px;
        text-align: center;
      }
    `,
    imports: [
    AsyncPipe
],
    changeDetection: ChangeDetectionStrategy.OnPush
})
export class FilterCountComponent extends BaseComponent {
  @Input() filter: ListFilterService;

}
